// AIDEV-NOTE: Service para fotos de produtos — chamadas API para o backend admin
import api from './auth.service';
import type { ProdutoFoto, BatchFotosResponse } from '@azoupvendas/shared';

export const produtosFotosService = {
  /**
   * Lista fotos de um produto
   */
  async listarFotos(produtoCodigo: number): Promise<ProdutoFoto[]> {
    const res = await api.get<{ fotos: ProdutoFoto[] }>(`/admin/produtos-fotos/${produtoCodigo}`);
    return res.data.fotos;
  },

  /**
   * Busca fotos em batch para multiplos codigos de produto
   * AIDEV-PERF: Evita N+1 — uma unica chamada para todos os produtos da pagina
   * AIDEV-NOTE: Usa /produtos/fotos/batch (nao /admin/...) para ser acessivel por vendedores
   */
  async listarFotosBatch(codigos: number[]): Promise<BatchFotosResponse> {
    if (codigos.length === 0) return {};
    const res = await api.get<BatchFotosResponse>('/produtos/fotos/batch', {
      params: { codigos: codigos.join(',') }
    });
    return res.data;
  },

  /**
   * Upload de uma foto para um produto
   */
  async uploadFoto(produtoCodigo: number, file: File): Promise<ProdutoFoto> {
    const formData = new FormData();
    formData.append('foto', file);
    const res = await api.post<{ foto: ProdutoFoto }>(
      `/admin/produtos-fotos/${produtoCodigo}`,
      formData,
      // AIDEV-NOTE: timeout maior que o global (30s) — upload de até 20MB em conexão lenta
      { headers: { 'Content-Type': 'multipart/form-data' }, timeout: 120_000 }
    );
    return res.data.foto;
  },

  /**
   * Remove uma foto
   */
  async deletarFoto(fotoId: string): Promise<void> {
    await api.delete(`/admin/produtos-fotos/${fotoId}`);
  },

  /**
   * Reordena fotos de um produto
   */
  async reordenarFotos(
    produtoCodigo: number,
    ordens: Array<{ id: string; ordem: number }>
  ): Promise<void> {
    await api.patch(`/admin/produtos-fotos/${produtoCodigo}/ordem`, { ordens });
  }
};
